"use client";

import { useState } from "react";
import GrowWealthChevron from "@/app/assets/icons/grow-wealth/chevron-right";
import ArrowDownToLineIcon from "@/app/assets/icons/who-is-icm-for/arrow-down-to-line";
import GetICMAppModal from "@/app/components/get-icm-app-modal";
import TrackedLink from "@/app/components/icm 3.0/shared/TrackedLink";
import { useMobileNavOpen } from "@/app/components/icm 3.0/shared/mobile-nav-open";
import { DirectPaths } from "@/config/routes";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { cn } from "@/lib/utils";

/**
 * Homepage mobile sticky CTA bar — Figma 2541:30905
 * Fixed to the bottom on small screens only.
 * When MobileNavMenu is open, drop under the nav stacking context (header z-50)
 * so the full-screen drawer covers this bar.
 */
const MobileStickyCtaBar = () => {
    const [showAppModal, setShowAppModal] = useState(false);
    const mobileNavOpen = useMobileNavOpen();

    const handleDownloadApp = () => {
        void setAnalyticsEvent(DirectPaths.HOME, "Home_Sticky_Download_App");
        setShowAppModal(true);
    };

    return (
        <>
            <div
                className={cn(
                    "fixed inset-x-0 bottom-0 flex flex-col items-center justify-center bg-white pb-6 pt-4 md:hidden",
                    // Menu lives inside header (z-50); keep this below it while open.
                    mobileNavOpen ? "pointer-events-none z-40" : "z-[100]",
                )}
                role="region"
                aria-label="Quick actions"
                aria-hidden={mobileNavOpen}
            >
                <div className="flex items-center gap-3.5">
                    <TrackedLink
                        href="/login"
                        event="Home_Sticky_Start_Investing"
                        className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-[var(--radius-m)] bg-cta-primary px-4 py-2 text-sm font-medium leading-5 text-cta-primary-text no-underline transition-colors hover:bg-cta-primary-hover hover:text-cta-primary-text-hover"
                        tabIndex={mobileNavOpen ? -1 : undefined}
                    >
                        Start Investing
                        <GrowWealthChevron />
                    </TrackedLink>

                    <button
                        type="button"
                        onClick={handleDownloadApp}
                        disabled={mobileNavOpen}
                        className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-[var(--radius-m)] border border-solid border-[#283A97] bg-white px-4 py-2 text-sm font-medium leading-5 text-[#283A97] transition-colors hover:bg-neutral-50"
                    >
                        Download the app
                        <ArrowDownToLineIcon />
                    </button>
                </div>
            </div>

            {/* Spacer so page content isn’t covered by the fixed bar (80px artboard) */}
            <div className="h-20 shrink-0 md:hidden" aria-hidden />

            <GetICMAppModal open={showAppModal} onClose={() => setShowAppModal(false)} />
        </>
    );
};

export default MobileStickyCtaBar;
